<template>
  <div class="tab">
    <div class="container">
      <div class="tab_group">
        <ul class="uk-tab uk-subnav" uk-switcher>
          <li class="tab_title" ref="tab_1" role="tab">
            <a class="item" href="#" title="影音專區">
              <img src="../img/Sharing1.svg" alt="" />
              <div :style="{ fontSize: fontSize.h4 + 'em' }">影音專區</div>
            </a>
          </li>
          <li class="tab_title" ref="tab_2" role="tab">
            <a class="item" href="#" title="專家建議區">
              <img src="../img/Sharing2.svg" alt="" />
              <div :style="{ fontSize: fontSize.h4 + 'em' }">專家建議</div>
            </a>
          </li>
          <li class="tab_title" ref="tab_3" role="tab">
            <a class="item" href="#" title="達人投稿區">
              <img src="../img/Sharing3.svg" alt="" />
              <div :style="{ fontSize: fontSize.h4 + 'em' }">達人投稿</div>
            </a>
          </li>
        </ul>
        <!-- //內文 -->
        <ul class="uk-switcher uk-margin PhoneRwd">
          <li class="video_wrap">
            <VideoCarousel :data="article.video" justify="VideoInner" />
            <div class="video_group">
              <template v-for="(video, i) in article.video" :key="i">
                <div class="video_item" v-if="i < 8">
                  <router-link class="web_pic_item" :to="{ name: 'VideoInner', params: { id: video.vid } }"
                    style="display: block" :title="video.title">
                    <div class="news_video">
                      <div class="iframe">
                        <div v-if="video.originalFilePath" v-html="video.originalFilePath"></div>
                        <div v-else>
                          <img :src="fakeImg" alt="" />
                        </div>
                      </div>
                    </div>
                    <p :style="{ fontSize: fontSize.p + 'em' }" class="text_content">
                      {{ video.title }}
                    </p>
                  </router-link>
                </div>
              </template>
            </div>
            <div class="more">
              <More justify="video" type="影音" />
            </div>
          </li>

          <li class="video_wrap">
            <PhoneShareTab :data="article.advice" justify="ArticlePage" />
            <div class="video_group">
              <template v-for="(item, i) in article.advice" :key="item.pageId">
                <div class="video_item" v-if="i < 8">
                  <router-link class="web_pic_item" :to="{
                    name: 'ArticlePage',
                    params: { pageId: item.pageId },
                  }" style="display: block" title="國際趨勢文章">
                    <div v-if="item.video" class="video">
                      <div class="iframe">
                        <div v-html="item.video" />
                      </div>
                    </div>
                    <div v-else class="pic">
                      <img :src="item.image" alt="國際趨勢圖片" />
                    </div>
                    <p class="text_content">{{ item.title }}</p>
                  </router-link>
                </div>
              </template>
            </div>
            <div class="more">
              <More justify="article" type="專家建議" />
            </div>
          </li>

          <li class="video_wrap">
            <PhoneShareTab :data="article.contribution" justify="SubmitPage" />
            <div class="video_group">
              <template v-for="(item, i) in article.contribution" :key="item.pageId">
                <div class="video_item" v-if="i < 8">
                  <router-link class="web_pic_item" :to="{
                    name: 'SubmitPage',
                    params: {
                      pageId: item.pageId,
                    },
                  }" style="display: block" title="國際趨勢文章">
                    <div v-if="item.video" class="video">
                      <div class="iframe">
                        <div v-html="item.video" />
                      </div>
                    </div>
                    <div v-else class="pic">
                      <img :src="item.image" alt="國際趨勢圖片" />
                    </div>
                    <p class="text_content">{{ item.title }}</p>
                  </router-link>
                </div>
              </template>
            </div>
            <div class="more">
              <More justify="submit" type="達人投稿" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import PhoneShareTab from "./Home/PhoneShareTab.vue";
import VideoCarousel from "./VideoCarousel.vue";
import More from "./Home/More.vue";
import { defineComponent, reactive, ref, inject } from "vue";
import { apiSeaAdvices, apiSeacontributor, apiVideoShare } from "@/api/api.js";
import { fakeImg } from "@/fake_data.js";
import { toArticleFormat } from "@/util/article";

export default defineComponent({
  name: "Tab",
  components: {
    PhoneShareTab,
    VideoCarousel,
    More,
  },
  data() {
    return {
      observer: new MutationObserver((mutationRecords) => {
        for (const { attributeName, target } of mutationRecords) {
          if (attributeName !== "class") return

          if (target.classList.contains("uk-active")) target.setAttribute("aria-selected", true)
          else target.removeAttribute("aria-selected")
        }
      })
    }
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");

    const searchingData = {
      keyword: "",
      page: 1,
    };
    const article = reactive({
      video: [],
      advice: [],
      contribution: [],
    });

    apiVideoShare(searchingData).then((res) => {
      res.data.videos.forEach((message) => {
        if (message.imageFiles === null)
          message.imageFiles = [{ fileId: "000", filePath: fakeImg }];
        article.video.push(message);
      });
    });

    const fetchAdvice = async () => {
      const {
        data: { expertAdvices },
      } = await apiSeaAdvices(searchingData);
      const items = expertAdvices.map((d) => toArticleFormat(d));

      article.advice = items;
    };

    const fetchContributor = async () => {
      const {
        data: { contributors },
      } = await apiSeacontributor(searchingData);
      const items = contributors.map((d) => toArticleFormat(d));

      article.contribution = items;
    };

    fetchAdvice();
    fetchContributor();

    return {
      tab_1: ref(),
      tab_2: ref(),
      tab_3: ref(),
      article,
      fontSize,
      fakeImg,
    };
  },
  mounted() {
    for (const tab of [this.tab_1, this.tab_2, this.tab_3]) {
      this.observer.observe(tab, { attributes: true })
    }
  }
});
</script>
<style scoped lang="scss">
img {
  width: 15%;

  @include sm {
    width: 23%;
  }

  @include xs {
    width: 29%;
  }
}

.item {
  @include sm {
    display: flex;
    flex-direction: column;
  }
}

//切換區
.tab {
  @include CulFlex_center();

  .tab_title {
    width: $width / 3;

    h4 {
      @include sm {
        font-size: $h5;
      }
    }
  }

  .uk-tab {
    width: 70%;
    margin: auto;
    justify-content: center;

    @include lg {
      width: 100%;
    }

    >* {
      @include sm {
        padding-left: 0;
      }
    }

    .uk-active>a {
      border-color: $green_color;
      border-bottom: 5px solid $green_color;
      color: $green_color;
    }
  }
}

//影片區
.video_group {
  @include flex_between();
  align-items: flex-start;
  flex-wrap: wrap;

  @include md {
    display: none;
  }

  .video_item {
    width: $width / 4.3;
    margin: 15px 0;
    text-align: left;

    .pic {
      width: 100%;
      // height: 180px;
      overflow: hidden;
      //維持圖片比例的黑魔法
      aspect-ratio: 16 / 9;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
      }
    }
  }

  .news_video {
    position: relative;
    width: 100%;
    height: 0;
    margin: 0 auto;
    padding-bottom: 56.25%;
  }

  .iframe {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    aspect-ratio: 16 / 9;

    :deep iframe {
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

.more {
  margin-top: 60px;
}
</style>
